<div class="no-content-container" [class.no-content-container--fit-content]="type() === 'fit-content'">
  <div class="no-content-content">
    <div class="no-content-icon" [style.mask-image]="'url(assets/icons/no-rows-empty.svg)'" [style.-webkit-mask-image]="'url(assets/icons/no-rows-empty.svg)'"></div>
    @if (message1()) {
      <p class="no-content-message" data-testid="no-content-message-primary">{{ message1() }}</p>
    }
    @if (message2()) {
      <p class="no-content-message" data-testid="no-content-message-secondary">{{ message2() }}</p>
    }
  </div>
</div>
